import React from 'react'
import styled from 'styled-components'
import Container from '../Components/Container'
import Title from '../Components/Title'
import {
  gitIcon,
  githubIcon,
  graphqlIcon,
  htmlIcon,
  javaIcon,
  javascriptIcon,
  mongodbIcon,
  mysqlIcon,
  nodejsIcon,
  pythonIcon,
  reactIcon,
  sassIcon,
  webpackIcon,
  pandasIcon,
  djangoIcon
} from '../Assets/Images'

const About = () => {
  return (
    <Container>
      <Wrapper>
        <Title>About</Title>
        <Description>
          Full-Stack Web Developer with 3 years of experience from Ottawa,
          Canada. I love coding and solving challenges regardless of the area.
          <br />
          <br />
          I have a huge passion about Programming. I love learning something new
          every day and I think that every developer must learn day-to-day in
          order to stay up-to-date with all technologies.
          <br />
          <br />
          My objective is to be useful for my client, and to build, test and
          develop high-quality projects that will satisfy my customers' needs.
        </Description>

        <br />
        <br />
        <hr />
        <br />
        <br />

        <Title>My Hobbies</Title>
        <List>
          <li>Coding</li>
          <li>Data Analysis</li>
          <li>Problem Solving</li>
          <li>UI Design</li>
          <li>Reading</li>
          <li>Workout</li>
          <li>Playing Guitar, Piano</li>
          <li>Motion Design</li>
        </List>

        <br />
        <br />
        <hr />
        <br />
        <br />

        <Title>Stack</Title>
        <List>
          <Image src={gitIcon} />
          <Image src={githubIcon} />
          <Image src={graphqlIcon} />
          <Image src={htmlIcon} />
          <Image src={javaIcon} />
          <Image src={javascriptIcon} />
          <Image src={mongodbIcon} style={{ width: 120 }} />
          <Image src={mysqlIcon} style={{ width: 80 }} />
          <Image src={nodejsIcon} style={{ width: 80 }} />
          <Image src={pythonIcon} />
          <Image src={reactIcon} style={{ width: 80 }} />
          <Image src={sassIcon} />
          <Image src={webpackIcon} />
          <Image src={pandasIcon} style={{ width: 80 }} />
          <Image src={djangoIcon} style={{ width: 80 }} />
        </List>

        <br />
        <br />
        <hr />
        <br />
        <br />

        <Title>Objectives</Title>
        <Description>
          <List>
            <li>Achieve professional goals</li>
            <li>Master code every day</li>
            <li>Pay attention to details</li>
            <li>Only 100% outcome</li>
            <li>Never give up</li>
            <li>Stay calm and positive</li>
            <li>Satisfy client's needs</li>
          </List>
        </Description>
        <br />
        <br />
      </Wrapper>
    </Container>
  )
}

const Wrapper = styled.div`
  margin-top: 40px;
`

const Description = styled.p`
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
`

const List = styled.ul`
  li {
    color: #ffffff;
    font-size: 16px;
    list-style: none;
    margin-bottom: 10px;

    &::before {
      content: '— ';
    }
  }
`

const Image = styled.img`
  width: 60px;
  margin: 20px;
`

export default About
